import { useMutation } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';

import OpenNotification from 'src/app/components/antd/OpenNotification';

import { apiCancellationFunnels } from '../../api';
import { QuestionPayload } from '../../types/questionPageTypings';

export function useTryToRequestCreatingQuestionFunnelPage() {
  const navigate = useNavigate();

  const { mutateAsync, isPending: isLoading } = useMutation({
    mutationFn: async (payload: QuestionPayload) => {
      return await apiCancellationFunnels.tryToRequestCreatingQuestionFunnelPage(
        payload
      );
    },
    onSuccess: () => {
      navigate(-1);
    },
    onError: () => {
      OpenNotification(
        true,
        'Erro ao criar o funil de Perguntas',
        'Ocorreu um erro ao criar o funil de Perguntas, por favor tente novamente mais tarde.'
      );
    },
  });

  return { tryToRequestCreatingQuestion: mutateAsync, isLoading };
}
